import { render, staticRenderFns } from "./quick-replies.vue?vue&type=template&id=7824939c&"
import script from "./quick-replies.vue?vue&type=script&lang=js&"
export * from "./quick-replies.vue?vue&type=script&lang=js&"
import style0 from "./quick-replies.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports